import { createAuthApi } from '@e-learning/core';
import { ForgotPassword, i18n } from '@e-learning/shared';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../../../api/client';
import { getDefaultLoginBranding } from '../Login/loginBranding';

const authApi = createAuthApi(api);

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tokenFromQuery = searchParams.get('token');
  const emailFromQuery = searchParams.get('email');
  const branding = getDefaultLoginBranding(t);

  // O backend escolhe o template (EN/ES). A UI usa i18n.language ('en-US' | 'es').
  const templateLanguage = i18n.language?.toLowerCase().startsWith('es')
    ? 'ES'
    : 'EN';
  return (
    <div data-e2e="page-admin-forgot-password">
      <ForgotPassword
        branding={branding}
        initialToken={tokenFromQuery ?? undefined}
        initialEmail={emailFromQuery ?? undefined}
        onRequestToken={async (email: string) => {
          await authApi.forgotPassword(
            { email },
            { acceptLanguage: templateLanguage }
          );
        }}
        onResetPassword={async ({
          token,
          newPassword,
        }: {
          token: string;
          newPassword: string;
        }) => {
          await authApi.resetPassword(
            { token, newPassword },
            { acceptLanguage: templateLanguage }
          );
        }}
        onBackToLogin={() => navigate('/')}
      />
    </div>
  );
}
